<h3>Language Selector</h3>
<div class="section">
    <form (change)="saveLanguage()">
        <p>Selected language: {{selectedLanguage}}</p>
        <label>
            <select class="language" name="language" [(ngModel)]="selectedLanguage">
                <option value="" [attr.selected]="!selectedLanguage ? 'selected' : null">Select a language</option>
                <optgroup *ngFor="let location of locations" [attr.label]="location.name">
                    <option *ngFor="let language of location.values"
                        [attr.value]="language.value"
                        [attr.selected]="selectedLanguage === language.value ? 'selected' : null"
                    >({{language.value}}) {{language.name}}</option>
                </optgroup>
            </select>
        </label>
    </form>
</div>
